import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import UTCheck from '../UTCheck';

import styles from './styles';

const UTCheckbox = ({ onChange, label, sublabel, value, withoutLabel, style, name }) => {
  const styleVar = value ? styles.activeButton : styles.inactiveButton;
  return withoutLabel ? (
    <div name={name} style={styles.container}>
      <UTTouchableWithoutFeedback
        style={value ? styles.activeButton : styles.inactiveButton}
        onClick={onChange}
      />
    </div>
  ) : (
    <div name={name} style={styles.container}>
      <UTTouchableWithoutFeedback style={{ ...styleVar, ...style }} onClick={onChange}>
        <UTCheck style={styles.checkedOk} />
      </UTTouchableWithoutFeedback>

      <UTTouchableWithoutFeedback onClick={onChange}>
        <UTLabel small>{label}</UTLabel>
        {sublabel && <UTLabel small>{sublabel}</UTLabel>}
      </UTTouchableWithoutFeedback>
    </div>
  );
};

UTCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  value: PropTypes.bool.isRequired,
  withoutLabel: PropTypes.bool,
  name: PropTypes.string
};

export default Radium(UTCheckbox);
